import { createContext, useContext } from "react"

import type { Workspace } from "@/lib/workspace/mod"
import type { User } from "@/lib/user/mod"

export type AuthBroadcastChannelEvent =
  | {
      loggedIn: true
      authState: AuthState
    }
  | {
      loggedIn: false
    }

export const AuthChannelName = "auth-state"

export type AuthState = {
  user: User | null
  workspace: Workspace | null
}
export const AuthContext = createContext<AuthState>({
  user: null,
  workspace: null,
})

export function useCurrentUser() {
  const authState = useContext(AuthContext)
  return authState.user
}

export function useCurrentWorkspace() {
  const authState = useContext(AuthContext)
  return authState.workspace
}
